<script>
// http://localhost/?quicklink=0dce6670160d28c1945769b03fbac413#/
// import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { configStore } from "@common/configStore";
import { actionStore } from "@common/actionStore";
import { library } from "@common/library/library";
import { recordStore } from "@common/recordStore";

const editorSettings = {
    tabs: {
        label: 'Tabs list',
        type: 'ARRAY',
        id: 'tabsList',
        itemConfig: {
            primaryLabel: 'Tab',
            itemType: 'object',
            permissions: {
                allowAddItem: true,
            },
            keys: {
                tabName: {
                    type: 'string',
                    id: 'tabName',
                    label: 'Tab Name',
                    helpText: 'Create name for tab'
                },
                tabTemplate: {
                    type: 'text',
                    id: 'tabTemplate',
                    label: 'Tab template',
                    helpText: 'Input config for tab template or component'
                    // ENABLE_HTML: true
                }
            },
            newItem: {
                textProp: 'a new text prop',
                numberProp: 1
            }
        },
        helpText: 'Tabs configuration for webPostings'
    },
};

const webPostingManagerConfig = {
    cId: "webPostingManager",
    cType: "webPostingManager",
    cTitle: "Web Posting Manager",
    cTemplate: `<div>
        <div>
            <control name="NEW_POSTING_DROPDOWN"></control>
            <control name="NEW_POSTING_BUTTON"></control>
        </div>
        <div>
            <div v-for="(record, postingId) in existingPostings" class="web-posting-container">
                <div class="posting-item">
                    <div style="display: flex">
                        <div style="margin-right: 20px;">
                            <img v-for="(org, key) in record.AFFILIATED_ORGS" :src="org['ATTACHURL#Image']" title="Organization Image" class="aff-org-image"/>
                        </div>
                        <div>
                            <div style="float: right;" class="status-indicator">{{templateData[postingId].status}}</div>
                            <div class="posting-title">
                                <span v-for="(org, key) in record.AFFILIATED_ORGS">{{org.ORG_TITLE}}<span class="aff-seperator">/</span></span>
                            </div>
                            <p class="endpoint-url">
                                <strong>Website URL(endpoint): </strong>
                                <a :href="recruiterUrl + '/affiliation_details/' + postingId" target="_blank" title="Website URL (endpoint)">{{recruiterUrl}}/affiliation_details/{{postingId}}</a>
                            </p>
                        </div>
                    </div>
                    <ul class="posting-tabs">
                        <li @click="templateData[postingId].currentView='search'" :class="{ active: !templateData[postingId].currentView || templateData[postingId].currentView === 'search' }" title="Search Settings">Search Settings</li>
                        <li @click="templateData[postingId].currentView='details'" :class="{ active: templateData[postingId].currentView === 'details' }" title="Details">Web Details</li>
                        <li @click="templateData[postingId].currentView='signups'" :class="{ active: templateData[postingId].currentView === 'signups' }" title="Sign-up History">Sign-up History</li>
                        <li @click="templateData[postingId].currentView='admin'" :class="{ active: templateData[postingId].currentView === 'admin' }" title="admin">Admin</li>
                        <li v-for="tab in config.tabs" @click="templateData[postingId].currentView=tab.tabName" :class="{ active: templateData[postingId].currentView === tab.tabName }" :title="tab.tabName" >{{tab.tabName}}</li>
                    </ul>
                    <div v-if="!templateData[postingId].currentView || templateData[postingId].currentView === 'search'" class="posting-tab-container">
                        <div>
                            <control :name="'DISPLAY_IN_SEARCH__' + postingId"></control>
                        </div>
                        <div v-if="controls['DISPLAY_IN_SEARCH__' + postingId] && controls['DISPLAY_IN_SEARCH__' + postingId].value !== 'hide'">
                            <div v-if="Object.keys(availabilityWindows[postingId]).length">
                                <div class="dates-heading">Sign-up Windows <span>Enables the sign-up button</span></div>
                                <div v-for="window in availabilityWindows[postingId]" class="posting-window-item">
                                    <div class="posting-window-dates">
                                        <div class="signup-dates-block">
                                            <div class="signup-dates-controls">
                                                <div>
                                                    <control :name="'AAW_SIGNUP_START_DATE__' + window.aawId"></control>
                                                    <control :name="'AAW_SIGNUP_START_TIME__' + window.aawId"></control>
                                                </div>
                                                <div>
                                                    <control :name="'AAW_SIGNUP_END_DATE__' + window.aawId"></control>
                                                    <control :name="'AAW_SIGNUP_END_TIME__' + window.aawId"></control>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="display-dates-block" v-if="controls['DISPLAY_IN_SEARCH__' + postingId] && controls['DISPLAY_IN_SEARCH__' + postingId].value === 'windows'">
                                            <div class="display-dates-controls">
                                                <control :name="'AAW_DISPLAY_START_DATE__' + window.aawId"></control>
                                                <control :name="'AAW_DISPLAY_END_DATE__' + window.aawId"></control>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <control :name="'AAW_MAX_VOLUNTEERS__' + window.aawId"></control>
                                    </div>
                                    <div class="window-action-buttons">
                                        <control name="DELETE_AVAILABILITY_WINDOW" :actionParams="[window.aawId, postingId]"></control>
                                        <control name="UPDATE_AVAILABILITY_WINDOW" :actionParams="[window.aawId, postingId]"></control>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <p v-if="Object.keys(availabilityWindows[postingId]).length === 0">No Availability Windows.  Click "New Window" to create one.</p>
                            </div>
                            <div style="margin-top: 10px;">
                                <control name="NEW_AVAILABILITY_WINDOW" :actionParams="postingId"></control>
                            </div>
                        </div>
                    </div>
                    <div v-if="templateData[postingId].currentView === 'details'" class="posting-tab-container">
                        <div class="action-button-container">
                            <control v-if="Array.isArray(record.DETAIL_RECORD_ID) && record.DETAIL_RECORD_ID.length" name="EDIT_DETAILS_BUTTON__edit" label="Edit Detail Record" :actionParams="postingId" :disabled="templateData[postingId].detailRecordLoading"></control>
                            <control v-else name="EDIT_DETAILS_BUTTON__new" label="New Detail Record" :actionParams="postingId" :disabled="templateData[postingId].detailRecordLoading"></control>
                            <div v-if="templateData[postingId].detailRecordLoading" class="detail-record-loading-indicator">loading...</div>
                        </div>
                        <div v-if="Array.isArray(record.DETAIL_RECORD_ID) && record.DETAIL_RECORD_ID.length">
                            <div><strong>Detail Record: {{record.DETAIL_RECORD_ID[0]}}</strong></div>
                            <h1>{{record.DETAIL_RECORD.ORG_TITLE}}</h1>
                            <div class="description-header">Short Description:</div>
                            <div class="short-description">
                                {{record.DETAIL_RECORD.ORG_SHORT_DESCRIPTION}}
                            </div>
                            <div class="description-header">
                                Long Description:
                                <button type="button" style="border: 0 none; font-size: 16px; background: transparent; text-decoration: underline;" @click="templateData[postingId].showLongDesc = !templateData[postingId].showLongDesc">Show Long Description</button>
                            </div>
                            <div class="long-description" v-if="templateData[postingId].showLongDesc">
                                {{record.DETAIL_RECORD.ORG_LONG_DESCRIPTION}}
                            </div>
                        </div>
                        <div v-else>
                            <div><strong>Detail Record:</strong> <span style="color: #c20000; font-weight: bold;">Default Template!</span></div>
                            <h1 class="posting-title"><span v-for="(org, key) in record.AFFILIATED_ORGS">{{org.ORG_TITLE}}<span class="aff-seperator">/</span></span></h1>
                            <p class="alert alert-info"><strong>Note: </strong> Default details is a combination of the "location" and "sub-program" details.  If you want to customize these details click "New Detail Record".</p>
                        </div>
                    </div>
                    <div v-if="templateData[postingId].currentView === 'signups'" class="posting-tab-container">
                        <div><strong>Volunteers Who've Signed Up</strong></div>
                        <div v-if="Object.keys(availabilityWindows[postingId]).length">
                            <div v-for="window in availabilityWindows[postingId]">
                                <div><strong>{{window.AAW_SIGNUP_START_DATE}} - {{window.AAW_SIGNUP_END_DATE}}</strong></div>
                                <ul class="vol-signup-list">
                                    <li v-for="signupVol in window.VOL_SIGNUP_LIST">{{signupVol.VOL_FIRST_NAME}} {{signupVol.VOL_LAST_NAME}}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div v-if="templateData[postingId].currentView === 'admin'" class="posting-tab-container">
                        <div>Select your contact(s) for this assignment</div>
                        <p><strong>Coming soon!</strong></p>
                        <div style="display: flex;">
                            <div style="margin-right: 20px;">
                                <strong>Workflows (in order):</strong><br/>
                                <ul>
                                    <li v-for="workflow in record.ATTACHED_WORKFLOWS">{{workflow.WORKFLOW_TITLE}}</li>
                                </ul>
                            </div>
                            <div>
                                <strong>Forms:</strong><br/>
                                <p><strong>Coming soon!</strong></p>
                            </div>
                        </div>
                        <div>
                            <p>Expire this Posting.</p>
                            <p>
                                Expiring the posting will set it to an "expired" status. This will prevent it from displaying publicly, regardless of any configured posting windows.  To undo this, you can re-activate the posting.<br/><br/>
                                <strong>Note:</strong> This will not change reporting for volunteers/supervisors that have already applied to this posting and been given an assignment.  To change status with individuals, you will have to expire their individual assignments.<br/>
                                <strong>Note:</strong> In most cases it is recommended that you manage the publishing via the posting windows
                            </p>
                            <control name="UNPUBLISH_BUTTON"></control>
                        </div>
                    </div>
                    <div v-if="visibleConfiguredTabs[postingId]" class="posting-tab-container">
                        <component :is="visibleConfiguredTabs[postingId].tabTemplateId" :record="record"></component>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    controls: [
        {
            name: 'NEW_POSTING_DROPDOWN',
            type: 'dropdown',
            label: 'New Posting',
            fields: {
                text: 'ORG_TITLE',
                value: 'rowID'
            },
            itemsSource: [{
                source: ['ec_getGrid'],
                params: {
                    gridPsp: 'org',
                    gridRecord: false,
                    gridFields: ['ORG_TITLE', 'ORG_KIND', 'ORG_KIND_ID', 'WORKFLOW_ID', 'ORG_AFFILIATED_ORG_IDS']
                }
            }],
            itemsFilter: 'this.item.ORG_KIND_ID > 700',
            itemTemplate: `<div><strong>{{data.ORG_TITLE}}</strong><br/>Kind: {{data.ORG_KIND}}, Workflows: {{data.WORKFLOW_ID || 'none'}}</div>`
        },
        {
            name: 'NEW_POSTING_BUTTON',
            type: 'button',
            label: 'Create New',
            onclick: 'createPosting',
        },
        {
            name: 'UNPUBLISH_BUTTON',
            type: 'button',
            label: 'Unpublish Affiliation',
            onclick: 'unpublishPosting',
        },
        {
            name: 'DISPLAY_IN_SEARCH',
            type: 'radio',
            label: 'Display in Search (coming soon!)',
            inlineLabel: true,
            showInline: true,
            disabled: true,
            cssClass: 'search-display-control',
            fields: {
                text: 'text',
                value: 'value',
            },
            items: [
                { text: 'Hidden', value: 'hide' },
                { text: 'Always', value: 'always' },
                { text: 'Using Dates', value: 'dates' },
                { text: 'Using Posting Window Dates', value: 'windows' },
            ]
        },
        {
            name: 'NEW_AVAILABILITY_WINDOW',
            type: 'button',
            label: 'New Window',
            onclick: 'newAvailabilityWindow',
        },
        {
            name: 'UPDATE_AVAILABILITY_WINDOW',
            type: 'button',
            label: 'Save Window',
            onclick: 'updateAvailabilityWindow',
        },
        {
            name: 'DELETE_AVAILABILITY_WINDOW',
            type: 'button',
            label: 'Delete Window',
            onclick: 'deleteAvailabilityWindow',
        },
        {
            name: 'EDIT_DETAILS_BUTTON',
            type: 'button',
            onclick: 'editDetails',
        },
        // Sub controls for availability windows
        {
            name: 'AAW_DISPLAY_START_DATE',
            type: 'date',
            label: 'Display Start Date',
            width: '200px',
        },
        {
            name: 'AAW_DISPLAY_END_DATE',
            type: 'date',
            label: 'Display End Date',
            width: '200px',
        },
        {
            name: 'AAW_SIGNUP_START_DATE',
            type: 'date',
            label: 'Start Date/Time',
            width: '200px',
        },
        {
            name: 'AAW_SIGNUP_END_DATE',
            type: 'date',
            label: 'End Date/Time',
            width: '200px',
            message: 'Leave blank to display until full.'
        },
        {
            name: 'AAW_SIGNUP_START_TIME',
            type: 'time',
            label: 'Start Time',
            cssClass: 'time-control',
            width: '100px',
            hideLabel: true,
            valueAsNumber: true
        },
        {
            name: 'AAW_SIGNUP_END_TIME',
            type: 'time',
            label: 'End Time',
            cssClass: 'time-control',
            width: '100px',
            hideLabel: true,
            valueAsNumber: true
        },
        {
            name: 'AAW_MAX_VOLUNTEERS',
            type: 'number',
            min: 1,
            label: 'Max Volunteers',
            width: '160px',
            cssClass: 'max-openings-control'
        },

    ]
};

const webPostingManagerCmp = {
    name: "webPostingManager",
    editorSettings: editorSettings,
    props: {},
    data() {
        return {
            templateData: {},
            localAvailabilityWindows: {},
            availablePrograms: [],
            templateUniqueId: library.getUniqueID()
        };
    },
    computed: {
        tabTemplates() {
            let createComp = (tab, tabIndex) => {
                let iTemplateCmpId = "tabTemplate_"
                    + this.cId.replace(" ", /_/g).toLowerCase()
                    + "_" + tabIndex
                    + "_" + this.templateUniqueId;
                let iTemplate = "<div>" + tab.tabTemplate + "</div>";
                let component = this;
                let recordStore = this.recordStore;
                vueApp.component(iTemplateCmpId, {
                    template: iTemplate,
                    data() {
                        return {
                            templateData: {}, // A place to put custom, local, template specific settings
                            component: component
                        };
                    },
                    props: {
                        hovered: {
                            type: Boolean,
                            default: false
                        },
                        targeted: {
                            type: Boolean,
                            default: false
                        },
                        record: {
                            type: Object,
                            default() {
                                return {};
                            }
                        },
                        index: {}
                    },
                    computed: {
                        moment() {
                            return library.getMomentObj();
                        },
                        actionStore() {
                            return actionStore;
                        },
                        records() {
                            return recordStore.records;
                        }
                    },
                    methods: {
                        trimHTML(str) {
                            return library.trimHTML(str);
                        },
                        dateDetails(dateStr, formatStr) {
                            let momentDate = library.getMoment(dateStr, formatStr);
                            return {
                                D: momentDate.format('D'),
                                MMM: momentDate.format('MMM'),
                                dddd: momentDate.format('dddd'),
                            };
                        },
                        toggleDelay(time, property) {
                            this.templateData[property] = !this.templateData[property];
                            setTimeout(() => {
                                this.templateData[property] = !this.templateData[property];
                            }, parseInt(time, 10));
                        }
                    }
                });
                return iTemplateCmpId;
            };
            let tmpTabs = this.config.tabs || [];
            return tmpTabs.map((tab, tabIndex) => createComp(tab, tabIndex));
        },
        visibleConfiguredTabs() {
            let output = {};
            let postingIds = Object.keys(this.existingPostings);
            if (!this.tabTemplates) return output;
            let tmpTabs = this.config.tabs || [];
            tmpTabs.forEach((tab, tabIndex) => {
                let templateId = 'tabTemplate_'
                    + this.cId.replace(" ", /_/g).toLowerCase()
                    + "_" + tabIndex
                    + "_" + this.templateUniqueId;
                postingIds.forEach((postingId) => {
                    if (this.templateData[postingId].currentView === tab.tabName) {
                        output[postingId] = {
                            tabName: tab.tabName,
                            tabTemplateId: templateId
                        };
                    }
                });
            });
            return output;
        },
        recruiterUrl() {
            let url = '/custom/' + this.recruiterSettings.RECRUITER_ID;
            if (!this.configStore.devDashLocalInstanceDetails) {
                configStore.getDevDashLocalInstanceDetails();
                return url;
            }
            return this.configStore.devDashLocalInstanceDetails.url + url;
        },
        existingPostings() {
            let payload = {
                source: 'sds_getAffiliationList',
                params: {
                    fields: {
                        3: ["ATTACHURL#Image", "ORG_SHORT_DESCRIPTION", "ORG_LONG_DESCRIPTION", "ORG_TITLE", "CA#Website/Type_of_service#ICON"],
                        32: ["DETAIL_RECORD_ID"]
                    },
                    orgId: this.contextOrgId,
                    affType: 'org_org'
                }
            };
            let subscription = this.recordStore.subscribe(payload, this.cId, false, false);
            let output = this.recordStore.getSubscription(subscription.key);
            let affIds = Object.keys(output);
            affIds.forEach((postingId) => {
                if (!this.templateData[postingId]) {
                    this.templateData[postingId] = {
                        status: 'Active',
                        detailRecordLoading: false
                    };
                }
            });
            return output;
        },
        availabilityWindows() {
            let output = {};
            let affIds = Object.keys(this.existingPostings);
            let subscription = this.recordStore.subscribe({
                source: 'sds_getAffAvailabilityWindows',
                params: { affIds }
            });
            let records = this.recordStore.getSubscription(subscription.key);
            // Merge local-only records while we wait for the subscription to update
            for (let aawId in this.localAvailabilityWindows) {
                if (aawId === 'length') continue;
                let wRecord = this.localAvailabilityWindows[aawId];
                if (!records[aawId]) records[aawId] = wRecord;
            }
            records = records ? Object.values(records) : [];
            affIds.forEach((affId) => {
                affId = Number(affId);
                if (!output[affId]) output[affId] = {};
                let affWindows = records.filter((record) => record.AFFILIATION_ID === affId);
                // Set control values in the aff windows
                affWindows.forEach((wRecord) => {
                    let aawId = wRecord.AFF_AVAILABILITY_WINDOW_ID;
                    let fields = Object.keys(wRecord);
                    if (!wRecord.valuesLoaded) wRecord.valuesLoaded = {};
                    fields.forEach((field) => {
                        let control = this.controls[field + '__' + aawId];
                        if (!wRecord.valuesLoaded[field]) {
                            if (control) {
                                wRecord.valuesLoaded[field] = true;
                                control.value = wRecord[field];
                            }
                        }
                        else {
                            // Set the new record value from the control
                            if (control) wRecord[field] = control.value;
                        }
                    });
                    wRecord.aawId = aawId;
                    output[affId][aawId] = wRecord;
                });
            });
            return output;
        },
    },
    methods: {
        async createPosting() {
            if (this.controls.NEW_POSTING_DROPDOWN.value && this.contextOrgId) {
                let affiliationFields = {
                    AFF_STATUS: 4 // active
                };
                let response = await this.sDs.post('sds_createAffiliation', false, this.contextOrgId, affiliationFields, this.controls.NEW_POSTING_DROPDOWN.value);
                if (response.status === 'success') library.showToast('Posting created successfully.');
            }
        },
        async unpublishPosting(affId) {
            let response = await this.sDs.post('sds_updateAffiliation', affId, { AFF_STATUS: 'expired' });
            if (response.status === 'success') library.showToast('Posting removed successfully.');
        },
        async newAvailabilityWindow(_event, _control, affId) {
            let response = await this.sDs.post('sds_createAffAvailabilityWindow', affId, {});
            if (response.status === 'success') {
                // put the posting into the interface
                let windowId = response.data;
                let windowObj = {
                    aawId: windowId,
                    AFF_AVAILABILITY_WINDOW_ID: windowId,
                    AFFILIATION_ID: affId
                };
                this.localAvailabilityWindows[windowId] = windowObj;
            }
        },
        checkWindows() {
            // Check to see if any window was changed, and update it
        },
        async updateAvailabilityWindow(_event, _control, params) {
            let [aawId, affId] = params;
            let windowDetails = this.availabilityWindows[affId][aawId];
            let response = await this.sDs.post('sds_updateAffAvailabilityWindow', aawId, windowDetails);
            if (response.status === 'success') {
                library.showToast('Record updated successfully.');
            }
        },
        async deleteAvailabilityWindow(_event, _control, params) {
            let [aawId, affId] = params;
            let response = await this.sDs.post('sds_deleteAffAvailabilityWindow', aawId);
            if (response.status === 'success') {
                // Update in recordStore
                // this.recordStore.removeRecordsFromStore({ aaw: [aawId] });
                library.showToast('Record removed successfully.');
            }
        },
        async editDetails(_event, _control, affId) {
            if (this.templateData[affId].detailRecordLoading) return false;
            let affRecord = this.existingPostings[affId];
            let recordId = affRecord.DETAIL_RECORD_ID
                && affRecord.DETAIL_RECORD_ID.length
                && affRecord.DETAIL_RECORD_ID[0];
            // Create New if no recordId or update existing
            if (!recordId) {
                // Create the detail record, attach it to the affiliation, then open the edit profile window for the detail record
                this.templateData[affId].detailRecordLoading = true;
                let res1 = await this.sDs.post('sds_createDetailRecord', []);
                if (res1.status === 'failure') return library.showToast('There was a problem loading this information.');
                recordId = res1.data;
                actionStore.openProfile({ recordPsp: 'org', recordId });
                let res2 = await this.sDs.post('sds_updateAffiliation', affId, { DETAIL_RECORD_ID: recordId });
                if (res2.status === 'failure') return library.showToast('There was a problem loading this information.');
                library.mergeObj(recordStore().records.aff[affId], { DETAIL_RECORD_ID: [recordId] });
                recordStore().setModified({ aff: [affId] });
                setTimeout(() => {
                    this.templateData[affId].detailRecordLoading = false;
                }, 100);
            } else {
                this.templateData[affId].detailRecordLoading = true;
                actionStore.openProfile({ recordPsp: 'org', recordId });
                setTimeout(() => {
                    this.templateData[affId].detailRecordLoading = false;
                }, 5000);
            }
            return true;
        },
        async getPostingDetails(org1Id, org2Id) {
            if (!org1Id || !org2Id) return;
            let response = await this.sDs.post('sds_getOrgRelationshipList', org1Id, false, ['ORG_TITLE', 'ORG_KIND_ID']);
        },
        manualSave() {
            // called when Apply/Finish button clicked in coordinator
        }
    }
};
componentStore.initComponent(webPostingManagerCmp, webPostingManagerConfig);

export { webPostingManagerConfig, webPostingManagerCmp };
export default webPostingManagerCmp;
</script>

<style scoped>
.detail-record-loading-indicator {
    text-align: center;
    padding: 7px 0;
    font-weight: bold;
    color: #666;
}
</style>
